import { __assign, __rest } from "tslib";
import React, { useMemo } from 'react';
import { Wrapper } from './pininput.style';
var RE_DIGIT = new RegExp(/^\d+$/);
export var PinInput = function (_a) {
    var _b = _a.classify, classify = _b === void 0 ? 'md' : _b, _c = _a.variant, variant = _c === void 0 ? 'outline' : _c, _d = _a.status, status = _d === void 0 ? 'normal' : _d, hint = _a.hint, message = _a.message, _e = _a.gap, gap = _e === void 0 ? '12px' : _e, _f = _a.type, type = _f === void 0 ? 'text' : _f, valueLength = _a.valueLength, value = _a.value, onChange = _a.onChange, _g = _a.id, id = _g === void 0 ? '' : _g, _h = _a.className, className = _h === void 0 ? '' : _h, props = __rest(_a, ["classify", "variant", "status", "hint", "message", "gap", "type", "valueLength", "value", "onChange", "id", "className"]);
    var valueItems = useMemo(function () {
        var valueArray = value ? value.split('') : '';
        var items = [];
        for (var i = 0; i < valueLength; i++) {
            var char = valueArray[i];
            if (RE_DIGIT.test(char)) {
                items.push(char);
            }
            else {
                items.push('');
            }
        }
        return items;
    }, [value, valueLength]);
    var focusToNextInput = function (target) {
        var nextElementSibling = target.nextElementSibling;
        if (nextElementSibling) {
            nextElementSibling.focus();
        }
    };
    var focusToPrevInput = function (target) {
        var previousElementSibling = target.previousElementSibling;
        if (previousElementSibling) {
            previousElementSibling.focus();
        }
    };
    var inputOnChange = function (e, idx) {
        var target = e.target;
        var targetValue = target.value.trim();
        var isTargetValueDigit = RE_DIGIT.test(targetValue);
        if (!isTargetValueDigit && targetValue !== '') {
            return;
        }
        var nextInputEl = target.nextElementSibling;
        // only delete digit if next input element has no value
        if (!isTargetValueDigit && nextInputEl && nextInputEl.value !== '') {
            return;
        }
        targetValue = isTargetValueDigit ? targetValue : ' ';
        var targetValueLength = targetValue.length;
        if (targetValueLength === 1) {
            var newValue = value.substring(0, idx) + targetValue + value.substring(idx + 1);
            onChange(newValue);
            if (!isTargetValueDigit) {
                return;
            }
            focusToNextInput(target);
        }
        else if (targetValueLength === valueLength) {
            onChange(targetValue);
            target.blur();
        }
    };
    var inputOnKeyDown = function (e) {
        var key = e.key;
        var target = e.target;
        if (key === 'ArrowRight' || key === 'ArrowDown') {
            e.preventDefault();
            return focusToNextInput(target);
        }
        if (key === 'ArrowLeft' || key === 'ArrowUp') {
            e.preventDefault();
            return focusToPrevInput(target);
        }
        var targetValue = target.value;
        // keep the selection range position
        // if the same digit was typed
        target.setSelectionRange(0, targetValue.length);
        if (e.key !== 'Backspace' || targetValue !== '') {
            return;
        }
        focusToPrevInput(target);
    };
    var inputOnFocus = function (e) {
        var target = e.target;
        // keep focusing back until previous input
        // element has value
        var prevInputEl = target.previousElementSibling;
        if (prevInputEl && prevInputEl.value === '') {
            return prevInputEl.focus();
        }
        target.setSelectionRange(0, target.value.length);
    };
    return (React.createElement(Wrapper, __assign({ className: "legion-pininput ".concat(className), id: id, gap: gap, classify: classify, variant: variant, status: status }, props),
        React.createElement("div", { className: 'legion-pininput__inner' }, valueItems.map(function (digit, idx) { return (React.createElement("input", { className: 'legion-pininput__input', key: idx, type: type, inputMode: 'numeric', autoComplete: 'one-time-code', pattern: '\\d{1}', maxLength: valueLength, defaultValue: digit, onChange: function (e) { return inputOnChange(e, idx); }, onKeyDown: inputOnKeyDown, onFocus: inputOnFocus })); })),
        message && React.createElement("span", { className: 'legion-pininput__message' }, message),
        hint && React.createElement("span", { className: 'legion-pininput__hint' }, hint)));
};
